import React, { useState, useEffect, useRef } from "react";
import WebViewer from "@pdftron/webviewer";
import httpClient from "../../lib/HttpClient";
import axiosClient from "../../lib/axios-client";
import download from "downloadjs";
import security from "../../services/Security";
import axios from "../../lib/axios-client";
import { CSSTransition } from "react-transition-group";
import { Container, Row, Col } from "react-grid-system";
import VideoApp from "../Video/VideoApp";
import {
  apiUrl,
  pdftronServerUrl,
  loadDocumentUrl,
} from "../../lib/axios-client";

import DownloadSVG from "../../images/icons/svg/share-link-download-mobile.svg";
import mobileMenu from "../../images/icons/svg/mobile-menu-icon.svg";
import CloseSVG from "../../images/icons/svg/close-black.svg";
import OopsImage from "../../images/icons/svg/oops-image.svg";
import ApprovedImage from "../../images/icons/svg/approved-banner.svg";
import styles from "./GuestViewer.module.scss";
import stampTool from "../../pdf/tools/Stamp";

import ConversationsPanel from "../Documents/ConversationsPanel";
import CommentPanel from "../Documents/CommentPanel";
import SidePanelSection from "../Documents/SidePanelSection";
import ApprovalCard from "../Documents/ApprovalCard";
import ApprovalCardMobile from "../Documents/ApprovalCardMobile";
import { set } from "date-fns";
import PDFTGuestViewer from "./PDFTGuestViewer";

const GuestViewer = (props) => {
  const hashUrl = props.match.params.hash_url;

  const [video, setVideo] = useState(null);
  const [error, setError] = useState(false);
  const [duration, setDuration, durationRef] = useStateRef(0);
  const [intervalId, setIntervalId] = useState(null);
  const [conversations, setConversations] = useState([]);
  const [showConversations, setShowConversations] = useState(false);
  const [conversationSelected, setConversationSelected] = useState(null);
  const [documentId, setDocumentId] = useState(null);
  const [currentPageIndex, setCurrentPageIndex] = useState(null);
  const [signatures, setSignatures] = useState([]);
  const [userSignatures, setUserSignatures] = useState([]);
  const [approval, setApproval] = useState({});
  const [approvalSubmitted, setApprovalSubmitted] = useState(null);
  const [session, setSession] = useState({});
  const [annotationsRetrieved, setAnnotationsRetrieved] = useState(false);
  const [showMobileSidePanel, setShowMobileSidePanel] = useState(false);
  const [documentApproved, setDocumentApproved] = useState(false);
  const [showCommentsPanel, setShowCommentsPanel] = useState(false);
  const [conversationBlockId, setConversationBlockId] = useState(null);

  const [currentXFDFHighlightString, setCurrentXFDFHighlightString] =
    useState(null);
  const [guestUserId, setGuestUserId] = useState(null);
  const [sessionId] = useState(
    [...Array(32)].map(() => Math.random().toString(36)[2]).join("")
  );
  const [documentDynamicFields, setDocumentDynamicFields] = useState([]);

  const addCommentStampImage = (xfdfHighlightString) => {
    let stampImageTag;
    const regexOne = /<imagedata><\/imagedata>/;
    const regexTwo = /<imagedata\/>/;

    if (xfdfHighlightString.match(regexOne)) {
      stampImageTag = /<imagedata><\/imagedata>/;
    } else if (xfdfHighlightString.match(regexTwo)) {
      stampImageTag = /<imagedata\/>/;
    }

    const xfdfWithStampImages = xfdfHighlightString.replace(
      stampImageTag,
      "<imagedata>data:image/svg+xml;base64,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</imagedata>"
    );

    return xfdfWithStampImages;
  };

  const addStampImageToPinComments = (conversations) => {
    const conversationsWithStamps = conversations.map((conversation) => {
      if (conversation.xfdf_highlight_string) {
        conversation.xfdf_highlight_string = addCommentStampImage(
          conversation.xfdf_highlight_string
        );
        return conversation;
      } else {
        return conversation;
      }
    });

    return conversationsWithStamps;
  };

  const toggleMobileMenu = () => {
    if (showMobileSidePanel) {
      setShowMobileSidePanel(false);
    } else {
      setShowMobileSidePanel(true);
    }
  };

  const renderApprovalSubmitted = (approval) => {
    let statusMessage;
    if (approval.status === "submit_new_version") {
      statusMessage = "New version requested";
    } else if (approval.status === "approved") {
      statusMessage = "Approved";
    } else if (approval.status === "approve_with_changes") {
      statusMessage = "Approved with changes";
    }
    setTimeout(() => setApprovalSubmitted(null), 3000);
    return <div className={styles.submissionConfirmation}>{statusMessage}</div>;
  };

  const loadConversations = () => {
    httpClient
      .get(`/documents/${documentId}/share_link/conversations/${hashUrl}.json`)
      .then((response) => {
        setConversations(addStampImageToPinComments(response.data));
      });
  };

  const handleVisibilityChange = async () => {
    if (document.visibilityState === "hidden") {
      await httpClient.put("/share_links/session/duration", {
        hash_url: hashUrl,
        session_id: sessionId,
        duration: durationRef.current,
      });
      setDuration(0);
      clearInterval(intervalId);
    } else {
      const intervalId = setInterval(() => {
        setDuration((value) => value++);
      }, 1000);
      setIntervalId(intervalId);
    }
  };

  const beforeunload = async () => {
    httpClient.put("/share_links/session/duration", {
      hash_url: hashUrl,
      session_id: sessionId,
      duration: durationRef.current,
    });
  };

  let documentContainer = null;

  useEffect(() => {
    httpClient
      .get(`${loadDocumentUrl()}/share_links/view/${hashUrl}`)
      .then((res) => {
        setVideo(res.data.video_document);

        const retrieveAnnotations = async () => {
          const sessionResponse = await httpClient.post(
            `/share_links/session/create.json`,
            {
              hash_url: hashUrl,
              session_id: sessionId,
            }
          );

          setConversationBlockId(`${sessionResponse.data.id}-general`);

          setDocumentApproved(sessionResponse.data.is_approved);

          setSession(sessionResponse.data);

          setGuestUserId(sessionResponse.data.guest_user_id);

          setDocumentId(sessionResponse.data.id);

          const beforeunload = async () => {
            httpClient.put("/share_links/session/duration", {
              hash_url: hashUrl,
              session_id: sessionId,
              duration: durationRef.current,
            });
          };

          const counterInterval = setInterval(() => {
            setDuration((prevDuration) => prevDuration + 1);
          }, 1000);

          setIntervalId(counterInterval);

          document.addEventListener("visibilitychange", handleVisibilityChange);

          document.addEventListener("beforeunload", beforeunload);

          // Get User Signatures
          const userSignaturesResponse = await httpClient.get(
            `/guest_user_signatures/${hashUrl}.json`
          );
          setUserSignatures(userSignaturesResponse.data);

          // Get Document Signatures
          const documentSignaturesResponse = await httpClient.get(
            `/documents/${sessionResponse.data.id}/guest_signatures/${hashUrl}.json`
          );

          setSignatures(documentSignaturesResponse.data);

          // Get Approval
          const documentApprovalsResponse = await httpClient.get(
            `/documents/${sessionResponse.data.id}/guest_user_approval/${sessionResponse.data.guest_user_id}/${hashUrl}.json`
          );
          setApproval(documentApprovalsResponse.data);

          // Get Comments
          const conversationsResponse = await httpClient.get(
            `/documents/${documentApprovalsResponse.data.id}/share_link/conversations/${hashUrl}.json`
          );

          setConversations(
            addStampImageToPinComments(conversationsResponse.data)
          );

          // Get Document Dynamic Fields
          const DocumentDynamicFieldsResponse = await httpClient.get(
            `/documents/${sessionResponse.data.id}/share_link/document_dynamic_fields/${hashUrl}.json`
          );
          setDocumentDynamicFields(DocumentDynamicFieldsResponse.data);

          // Check if all annotations are retrieved, once they are, set annotationsRetrieved to true so that the document can be loaded
          if (
            sessionResponse &&
            userSignaturesResponse &&
            documentSignaturesResponse &&
            documentApprovalsResponse &&
            conversationsResponse
          ) {
            setAnnotationsRetrieved(true);
          }
        };

        retrieveAnnotations();

        return () => {
          window.removeEventListener("beforeunload", beforeunload);
        };
      })
      .catch((error) => {
        setError(true);
      });
  }, []);

  const conversationsSectionClicked = () => {
    if (video) {
      setShowCommentsPanel(true);
    } else {
      setShowConversations(true);
    }
  };

  const onCloseCommentPanel = (
    closeConversationsPanel = false,
    removeHighlight
  ) => {
    if (removeHighlight) {
      const webViewerEl = document.getElementById("webViewer");
      const annotationManager =
        window.WebViewer.getInstance(webViewerEl).Core.annotationManager;
      const annot = annotationManager.getAnnotationById(conversationSelected);
      setConversationSelected(null);
      annotationManager.deleteAnnotation(annot);
    } else {
      if (video) {
        setShowCommentsPanel(false);
      } else {
        setConversationSelected(null);
      }
    }
  };

  const onCloseConversationPanel = () => {
    setShowConversations(false);
  };

  const onAnnotationSelect = (pageIndex, xfdfHighlightId) => {
    setConversationSelected(xfdfHighlightId);
  };

  const renderSidePanel = (document) => {
    let annotationCommentsCount = conversations.length;

    if (showMobileSidePanel) {
      return (
        <div className={styles.mobileSidePanelContainer}>
          <div className={styles.notCommentPanel}>
            {Object.keys(approval).length > 0 && renderApprovalCard()}
            {
              <SidePanelSection
                clickAction={() => conversationsSectionClicked()}
                type={"comments"}
                count={conversations.length > 0 && annotationCommentsCount}
                showMobileSidePanel={showMobileSidePanel}
              />
            }
          </div>
        </div>
      );
    } else {
      return (
        <div
          className={
            video ? styles.videoSidePanelContainer : styles.sidePanelContainer
          }
        >
          <div className={styles.notCommentPanel}>
            {Object.keys(approval).length > 0 && renderApprovalCard()}
            {
              <div className={styles.sidePanelSectionContainer}>
                <SidePanelSection
                  clickAction={() => conversationsSectionClicked()}
                  type={"comments"}
                  count={conversations.length > 0 && annotationCommentsCount}
                />
              </div>
            }
          </div>
        </div>
      );
    }
  };

  const renderApprovalCard = () => {
    return (
      <div className={styles.approvalCardContainerSidePanel}>
        {!approval.observer && (
          <div
            className={`${styles.sidePanelOptions} ${styles.sidePanelOptionsMyApproval}`}
          >
            <ApprovalCard
              hashUrl={props.match.params.hash_url}
              approval={approval}
              inGuestViewer={true}
              updateApproval={setApproval}
            />
          </div>
        )}
        <div className={styles.divider}></div>
      </div>
    );
  };

  const renderApprovalCardMobile = () => {
    return (
      <div className={styles.approvalCardContainer}>
        {!approval.observer && (
          <div
            className={`${styles.sidePanelOptions} ${styles.sidePanelOptionsMyApproval}`}
          >
            <ApprovalCardMobile
              setApprovalSubmitted={setApprovalSubmitted}
              hashUrl={props.match.params.hash_url}
              approval={approval}
              inGuestViewer={true}
              updateApproval={setApproval}
            />
          </div>
        )}
        <div className={styles.divider}></div>
      </div>
    );
  };

  const downloadVideoFile = () => {
    const url = `/share_links/download`;
    const token = security.getToken();

    axiosClient({
      method: "post",
      url: url,
      responseType: "arraybuffer",
      headers: { Authorization: `Bearer ${token}` },
      data: {
        hash_url: hashUrl,
        session_id: sessionId,
        video_download: true,
      },
    });

    axios({
      method: "get",
      url: video.video_download_url,
      responseType: "arraybuffer",
    }).then(function (response) {
      download(response.data, video.video_file_name);
    });
  };

  return (
    <div className={styles.reviewerScreenContainer}>
      <div id="usersScreenHeader"></div>
      <div className={styles.headerContainer}>
        {video && !documentApproved && (
          <div className={styles.header} id="document_view_header">
            {video && video.document_title}
          </div>
        )}
        {video && !documentApproved && (
          <button
            className={styles.downloadButtonDesktop}
            onClick={() => downloadVideoFile()}
          >
            Download
          </button>
        )}
        {video && !documentApproved && (
          <div
            className={styles.downloadButtonMobile}
            onClick={() => downloadVideoFile()}
          >
            <img src={DownloadSVG} />
          </div>
        )}
        {!video && !error && !documentApproved && (
          <React.Fragment>
            <div className={styles.header} id="document_view_header">
              {session.title ? `${session.title}` : ""}
            </div>
          </React.Fragment>
        )}
        {!error && !documentApproved && (
          <div className={styles.menuContainer}>
            {!showMobileSidePanel && (
              <img
                src={mobileMenu}
                onClick={() => {
                  toggleMobileMenu();
                }}
              />
            )}
            {showMobileSidePanel && (
              <img
                src={CloseSVG}
                onClick={() => {
                  toggleMobileMenu();
                }}
              />
            )}
          </div>
        )}
      </div>
      <div
        className={
          Object.keys(approval).length > 0 && approval.status === "pending"
            ? styles.containerApprovalsPresent
            : styles.container
        }
        id="document_container"
      >
        {!error && !documentApproved && (
          <React.Fragment>
            {video && (
              <React.Fragment>
                <Col
                  sm={9}
                  ref={(element) => {
                    documentContainer = element;
                  }}
                >
                  <VideoApp doc={video} documentContainer={documentContainer} />
                </Col>{" "}
              </React.Fragment>
            )}
          </React.Fragment>
        )}
        {!video && annotationsRetrieved && !error && !documentApproved && (
          <PDFTGuestViewer
            guestUserId={guestUserId}
            documentId={documentId}
            userSignatures={userSignatures}
            signatures={signatures}
            approval={approval}
            conversations={conversations}
            documentDynamicFields={documentDynamicFields}
            session={session}
            hashUrl={hashUrl}
            setConversationSelected={setConversationSelected}
            setCurrentXFDFHighlightString={setCurrentXFDFHighlightString}
            setSignatures={setSignatures}
            onCloseConversationPanel={onCloseConversationPanel}
            setCurrentPageIndex={setCurrentPageIndex}
            setUserSignatures={setUserSignatures}
            setError={setError}
            sessionId={sessionId}
            reloadConversations={loadConversations}
          />
        )}
        {!error &&
          annotationsRetrieved &&
          !documentApproved &&
          renderSidePanel()}
        <CSSTransition
          in={showConversations}
          classNames="slide"
          unmountOnExit
          timeout={300}
        >
          <ConversationsPanel
            inGuestViewer={true}
            showMobileSidePanel={showMobileSidePanel}
            conversations={conversations}
            closeConversationsPanel={onCloseConversationPanel}
            showAnnotationComments={onAnnotationSelect}
            reloadConversations={loadConversations}
            hashUrl={props.match.params.hash_url}
          />
        </CSSTransition>
        <CSSTransition
          in={conversationSelected || showCommentsPanel}
          classNames="slide"
          unmountOnExit
          timeout={300}
        >
          <CommentPanel
            conversationBlockId={conversationBlockId}
            is_video={video}
            docId={documentId}
            showMobileSidePanel={showMobileSidePanel}
            inGuestViewer={true}
            currentXfdfHighlightId={conversationSelected}
            closeConversation={onCloseCommentPanel}
            pageNumber={currentPageIndex}
            currentXfdfHighlightString={currentXFDFHighlightString}
            hashUrl={props.match.params.hash_url}
            reloadConversations={loadConversations}
            conversationSelected={conversationSelected}
            guestUserId={guestUserId}
            selectedConversationId={
              conversations.length > 0 &&
              conversations.find(
                (c) => c.xfdf_highlight_id === conversationSelected
              )
                ? conversations.find(
                    (c) => c.xfdf_highlight_id === conversationSelected
                  ).id
                : null
            }
          />
        </CSSTransition>
        {error && (
          <div className={styles.errorState}>
            <div className={styles.text}>
              <div className={styles.header}>oops!</div>
              <div className={styles.text}>
                Looks like this link no longer exists
              </div>
            </div>
            <div className={styles.image}>
              <img src={OopsImage} />
            </div>
          </div>
        )}
        {error && (
          <div className={styles.mobileErrorState}>
            <div className={styles.errorImage}>
              <img src={OopsImage} />
            </div>
            <div className={styles.mobileErrorStateText}>
              <div className={styles.mobileErrorStateHeader}>oops!</div>
              <div className={styles.Errortext}>
                Looks like this link no longer exists
              </div>
            </div>
          </div>
        )}
        {!error && documentApproved && (
          <div className={styles.errorState}>
            <div className={styles.text}>
              <div className={styles.header}>Approved!</div>
              <div className={styles.text}>
                Looks like this content is already approved
              </div>
            </div>
            <div className={styles.image}>
              <img src={ApprovedImage} />
            </div>
          </div>
        )}
        {!error && documentApproved && (
          <div className={styles.mobileErrorState}>
            <div className={styles.errorImage}>
              <img src={ApprovedImage} />
            </div>
            <div className={styles.mobileErrorStateText}>
              <div className={styles.mobileErrorStateHeader}>Approved!</div>
              <div className={styles.Errortext}>
                Looks like this content is already approved
              </div>
            </div>
          </div>
        )}
      </div>
      {Object.keys(approval).length > 0 &&
        approval.status === "pending" &&
        renderApprovalCardMobile()}
      {approvalSubmitted && renderApprovalSubmitted(approvalSubmitted)}
    </div>
  );
};

const useStateRef = (initialValue) => {
  const [value, setValue] = useState(initialValue);

  const ref = useRef(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return [value, setValue, ref];
};

export default GuestViewer;
